import { createAction } from 'redux-actions';
import * as actions from './actions';

export const fetchPaymentProductsRequest = createAction(actions.FETCH_PAYMENT_PRODUCTS_REQUEST);
export const fetchPaymentProductsSuccess = createAction(actions.FETCH_PAYMENT_PRODUCTS_SUCCESS);
export const fetchPaymentProductsFailure = createAction(actions.FETCH_PAYMENT_PRODUCTS_FAILURE);

export const postPaymentOrderRequest = createAction(actions.POST_PAYMENT_ORDER_REQUEST);
export const postPaymentOrderSuccess = createAction(actions.POST_PAYMENT_ORDER_SUCCESS);
export const postPaymentOrderFailure = createAction(actions.POST_PAYMENT_ORDER_FAILURE);

export const updatePaymentOrderRequest = createAction(actions.UPDATE_PAYMENT_ORDER_REQUEST);
export const updatePaymentOrderSuccess = createAction(actions.UPDATE_PAYMENT_ORDER_SUCCESS);
export const updatePaymentOrderFailure = createAction(actions.UPDATE_PAYMENT_ORDER_FAILURE);

export const fetchPaymentOrderRequest = createAction(actions.FETCH_PAYMENT_ORDER_REQUEST);
export const fetchPaymentOrderSuccess = createAction(actions.FETCH_PAYMENT_ORDER_SUCCESS);
export const fetchPaymentOrderFailure = createAction(actions.FETCH_PAYMENT_ORDER_FAILURE);

export const fetchPaymentClientSecretRequest =
  createAction(actions.FETCH_PAYMENT_CLIENT_SECRET_REQUEST);
export const fetchPaymentClientSecretSuccess =
  createAction(actions.FETCH_PAYMENT_CLIENT_SECRET_SUCCESS);
export const fetchPaymentClientSecretFailure =
  createAction(actions.FETCH_PAYMENT_CLIENT_SECRET_FAILURE);

export const postPaymentPayRequest = createAction(actions.POST_PAYMENT_PAY_REQUEST);
export const postPaymentPaySuccess = createAction(actions.POST_PAYMENT_PAY_SUCCESS);
export const postPaymentPayFailure = createAction(actions.POST_PAYMENT_PAY_FAILURE);

export const postPaymentInvoiceRequest = createAction(actions.POST_PAYMENT_INVOICE_REQUEST);
export const postPaymentInvoiceSuccess = createAction(actions.POST_PAYMENT_INVOICE_SUCCESS);
export const postPaymentInvoiceFailure = createAction(actions.POST_PAYMENT_INVOICE_FAILURE);

export const paymentSetActiveStep = createAction(actions.PAYMENT_SET_ACTIVE_STEP);
export const paymentSetMethod = createAction(actions.PAYMENT_SET_METHOD);
export const paymentSetIsUpdating = createAction(actions.PAYMENT_SET_IS_UPDATING);
export const paymentResetFlow = createAction(actions.PAYMENT_RESET_FLOW);
export const paymentCancelCheckout = createAction(actions.PAYMENT_CANCEL_CHECKOUT);

export const fetchOrdersRequest = createAction(actions.FETCH_ORDERS_REQUEST);
export const fetchOrdersSuccess = createAction(actions.FETCH_ORDERS_SUCCESS);
export const fetchOrdersFailure = createAction(actions.FETCH_ORDERS_FAILURE);
